// src/components/Admin/AdminMerchantCategories.js
"use client";

import { useEffect, useState } from "react";
import { Table, Button, Spinner, Badge } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import MerchantCategoryFormModal from "./MerchantCategoryFormModal";

const AdminMerchantCategoriesComp = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showFormModal, setShowFormModal] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  const fetchCategories = async () => {
    try {
      const { data } = await api.get("/merchant-categories");
      setCategories(data);
    } catch (err) {
      toast.error("خطا در دریافت دسته‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const toggleActive = async (category) => {
    try {
      if (category.isActive) {
        await api.delete(`/merchant-categories/${category.id}`);
        toast.success("دسته غیرفعال شد");
      } else {
        await api.patch(`/merchant-categories/${category.id}/activate`);
        toast.success("دسته فعال شد");
      }

      fetchCategories();
    } catch (err) {
      toast.error("خطا در تغییر وضعیت دسته");
    }
  };

  if (loading)
    return <Spinner animation="border" className="d-block m-auto mt-5" />;

  return (
    <>
      <div className="mb-3">
        <Button
          variant="primary"
          onClick={() => {
            setEditCategory(null);
            setShowFormModal(true);
          }}
        >
          افزودن دسته جدید
        </Button>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>نام دسته</th>
            <th>توضیحات</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>

        <tbody>
          {categories.map((c, idx) => (
            <tr key={c.id}>
              <td>{idx + 1}</td>

              <td>{c.title}</td>
              <td>{c.description}</td>

              <td>
                {c.isActive ? (
                  <Badge bg="success">فعال</Badge>
                ) : (
                  <Badge bg="secondary">غیرفعال</Badge>
                )}
              </td>

              <td className="d-flex gap-2">

                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => {
                    setEditCategory(c);
                    setShowFormModal(true);
                  }}
                >
                  ویرایش
                </Button>

                <Button
                  size="sm"
                  variant={c.isActive ? "danger" : "success"}
                  onClick={() => toggleActive(c)}
                >
                  {c.isActive ? "غیرفعال" : "فعال"}
                </Button>

              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <MerchantCategoryFormModal
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
        category={editCategory}
        onSuccess={fetchCategories}
      />
    </>
  );
};

export default AdminMerchantCategoriesComp;
